import React from "react";
import NewRiskView from "../components/NewRiskView";

function NewRisk({
  currentMenuItem,
  setCurrentMenuItem,
  projectId,
  setProjectId,
  reportId,
  setReportId,
  user,
}) {
  return (
    <div>
      <main className="flex-1">
        <div className="py-6">
          <NewRiskView
            currentMenuItem={currentMenuItem}
            setCurrentMenuItem={setCurrentMenuItem}
            projectId={projectId}
            setProjectId={setProjectId}
            reportId={reportId}
            setReportId={setReportId}
            user={user}
          />
        </div>
      </main>
    </div>
  );
}

export default NewRisk;
